import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph, RoboyuHappy} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {ValidateKYCModalProps} from './ValidateKYCModalProps'

const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(295)};
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
`

const StyledSubTitle = styled(Paragraph)`
  margin: ${convertUnit(15)} 0;
  padding: 0 ${convertUnit(20)};
  text-align: center;
`

const StyledDescription = styled(Paragraph)`
  margin: ${convertUnit(15)} 0;
  padding: 0;
  text-align: center;
`

const StyledTitle = styled(Paragraph)`
  text-align: center;
`

const StyledImageContainer = styled.div`
  text-align: center;
`

export default function TemplateSorryModalContent({
  visible,
  toggleModal,
}: ValidateKYCModalProps) {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <StyledModal visible={visible} onBackdropPress={toggleModal}>
      <StyledTitle fontSize="xl" fontWeight="bold">
        {translate('global:sorry')}
      </StyledTitle>
      <StyledSubTitle fontSize="m">
        {translate('giftShop:validateKYCModalSubTitle')}
      </StyledSubTitle>
      <StyledImageContainer>
        <RoboyuHappy
          width={convertUnit(200)}
          height={convertUnit(200)}
          colorTheme={colorTheme.name}
        />
      </StyledImageContainer>
      <StyledDescription fontSize="m" color="gray_6">
        {translate('giftShop:validateKYCModalDescription')}
      </StyledDescription>
      <Button label={translate('global:ok')} onClick={toggleModal} />
    </StyledModal>
  )
}
